module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gn-65edeaef7dabb0abc83498717b5f6ae1.svg";